import React from 'react'

// CSS
import "./index.css"

// Bootstrap Components
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';

// React Router
import { Link } from 'react-router';

export default function Footer() {
  return (
    <>
      <Navbar className="footerBar" bg="dark" data-bs-theme="dark">
        <Container fluid className="footerContent">
          
          <div className="footerBrandSection">
            <Link className='footerBarLink' to="/">Stocks With Nik</Link>
          </div>

          <div className="footerDisclaimer">
            <p className='footerDisclaimerText'>
              <strong>Disclaimer:</strong> I am not a financial advisor. All content on this website is for education and entertainment only. 
              Nothing here should be taken as financial advice. Always do your own research before making any investment decisions.
            </p>
          </div>

          <div className="footerCredits">
            <span style={{fontSize: "12px"}}>
              Designed by{" "}
              <a style={{color: "white"}} href="https://www.ddmwebdesigns.com" target='_blank' rel="noreferrer">
                DDM Web Designs
              </a>
            </span>
          </div>

        </Container>
      </Navbar>
    </>
  )
}
